// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/descent-technique.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/descent-technique/descent-technique.js';

mount([g0]);
